module.exports = __webpack_public_path__ + "static/media/vibino-feature-Add text-pic2.32f983cc.jpg";